module.exports = __webpack_public_path__ + "img/HuntingtonBank(Personal).e09f0580.svg";